/* LumaSpec system configurator on Shopify (/pages/configure; CONFIGURATOR lane). Port of the site's
   src/site/configurator/core.js - same step contract, same URL format (?camera=h~code~qty&lens=...&have=&set=&skip=&at=,
   ?<step>=<handle> from product pages, ?start=<step>), same filtered lists, summary and review. Differences:
   - data: the step files live in Shopify Files (src/store_configurator.py uploads them; URLs in #cfg-meta)
   - links: LSConfig.url(row) (row.u, else the store template META.purl) - one mapping, made in store_configurator.py
   - cart: /cart/add.js + Horizon's CartLinesUpdateEvent, so the cart drawer opens and refreshes
   - quote: window.LSQuote (ls-base.js, same storage key + item shape as the site), then the quote page
   - not sold in the US (owner 2026-10-21): rows with nu = 1 cannot be picked when the visitor's country is the US
   Loaded (defer) by sections/ls-configurator.liquid before assets/ls-cfg-steps.js (the site's step scripts, generated),
   which ends with LSConfig.start().

   A step registers itself (contract unchanged from the site):
     LSConfig.step("<key>", { filters, chips, fit(row, sys) -> [2|1|0, why], note(sys), apply(row, pick, sys), top(el, api),
       render(el, api), group(row), groups, rank(row, sys), extra(row, sys), onPick(row, api), qty, skip })
   api = {sys, rows, row(h), picks(), pick(handle, code, qty, note), add(handle, code, qty), note(text), unpick(handle),
          next(), set(name, value), refresh(), card(row, fitResult), list(el), money, esc} */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var money = function (v) { return '$' + Number(v).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); };
  var arr = function (v) { return v == null ? [] : Array.isArray(v) ? v : [v]; };
  var SW = { R: '#E5384A', G: '#2FB45A', B: '#2E6BEA', W: '#F4F6FA', IR: '#7B2D3B', UV: '#7A3FE0' };
  var PAGE = 24;

  var DEF = {}, META = null, DATA = {}, LOADING = {};
  var state = { picks: {}, have: null, extra: {}, skipped: {}, active: null, showAll: {}, filt: {}, page: {} };
  var sys = {};

  function url(r) {
    var link = r.u || (META.purl || '/products/{h}').replace('{h}', r.h);
    var parsed = new URL(link, window.location.origin);
    if (parsed.hostname !== window.location.hostname) return link;
    // Cached quote-only rows still carry pre-migration product URLs.
    if (/^\/p\/[^/]+\/?$/.test(parsed.pathname)) {
      parsed = new URL((META.purl || '/products/{h}').replace('{h}', r.h), window.location.origin);
    }
    if (parsed.pathname.indexOf('/products/') === 0) {
      var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
      return root.replace(/\/$/, '') + parsed.pathname + parsed.search + parsed.hash;
    }
    return link;
  }
  function quoteHandle(r) { return r.ns ? r.h : (META.qh || '{h}').replace('{h}', r.h); }
  function us() { return META && META.country === 'US'; }
  function blocked(r) { return !!(r && r.nu && us()); }  // not sold in the US (owner 2026-10-21)
  /* Interface strings: snippets/ls-cfg-i18n.liquid (locales ls.cfg.js / ls.quote.js; placeholders {n} in single braces
     so Liquid's t filter leaves them for this script), English defaults otherwise. "ui_map" there = shop metafield
     lsv.ui_map {English: translation}: the step data (step labels and questions, filter names and values, chips, fit
     reasons, notes, skip texts) is English and goes through tr() at display time only - never where it is matched
     against the parts data, used as a filter key or written into the URL. */
  var STR = {
    no_us: 'Not available in the United States. Available for delivery to other countries.',  // wording: session a4
    no_us_short: 'Not available in the United States', check: 'Check: {reason}', fit_unstated: 'fit not stated',
    no_fit: 'Does not fit', options_note: 'Options (size, colour, voltage...) are chosen on the product page or confirmed in the quote',
    add_to_quote: 'Add to quote', price_on_request: 'Price on request', quote: 'Quote', quote_small: 'quote',
    remove: 'Remove', selected: 'Selected', add: 'Add', select: 'Select', open_new_tab: 'Open {name} in a new tab',
    quantity: 'Quantity', any: 'Any', all: 'All', search: 'Search', search_placeholder: 'Model, size, focal length...',
    count_all: '{shown} of {total} parts', count_fit: '{shown} of {total} parts that fit', only_fit: 'Only parts that fit',
    also_show: "Also show {n} that don't fit", no_us_count: '{n} not available in the United States (listed last)',
    no_match: 'Nothing matches these filters.', clear_filters: 'Clear filters', show_more: 'Show more ({n} left)',
    choose_variant: 'Choose a colour / version first.', step_of: 'Step {n} of {total}', loading_parts: 'Loading parts...',
    back: 'Back', next_step: 'Next step', skip_step: 'Skip this step',
    load_error: 'Could not load the parts list. Please reload the page.', qty: 'Qty {n}',
    no_longer_fits: 'No longer fits: {reason}', check_step: 'check this step',
    pick_hint: 'Pick parts in the steps; they collect here.', any_order: 'Pick in any order', filters: 'Filters', filters_n: 'Filters ({n})',
    power_title: 'This light needs a power source',
    power_v: '{model} runs on {volt} V, and this system has no light controller or power source for it.',
    power_unknown: 'This system has no light controller or power source for {model}, and we have no supply voltage on file for it. Check the voltage on its product page before you order.',
    power_have: 'Already have a matching supply? You can still order as it is.',
    power_pc: '{model} runs on {volt} V. {pc} has {n} built-in light outputs: check that they supply this voltage, or add a light controller.',
    power_pc_unknown: 'We have no supply voltage on file for {model}. {pc} has {n} built-in light outputs: check the voltage on the product pages, or add a light controller.',
    power_choose: 'Choose a light controller',
    nous_one: '{n} part is not available in the United States (available for delivery to other countries) and is left out of the cart and the quote.',
    nous_other: '{n} parts are not available in the United States (available for delivery to other countries) and are left out of the cart and the quote.',
    bad_one: '{n} part no longer fits the system (an earlier choice changed). Change it in the steps above before checking out.',
    bad_other: '{n} parts no longer fit the system (an earlier choice changed). Change them in the steps above before checking out.',
    request_quote: 'Request a quote for this system', add_cart_one: 'Add {n} part to cart · {sum}',
    add_cart_other: 'Add {n} parts to cart · {sum}', quoted_parts: 'Quoted parts ({n})',
    on_quote_one: '{n} part goes on the quote request', on_quote_other: '{n} parts go on the quote request',
    on_request: '{n} priced on request', cart_takes: 'the cart takes the Buy now parts',
    copy_link: 'Copy link to this system', start_over: 'Start over', your_camera: 'Your camera', your_system: 'Your system',
    change: 'Change', skipped: 'Skipped', choose: 'Choose', priced_parts: 'Priced parts', parts_one: '{n} part',
    parts_other: '{n} parts', review: 'Review',
    checkout_note: 'Shipping and tax are calculated at checkout. Quote requests are answered within one business day.',
    nothing_yet: 'Nothing picked yet.', start_from: '{camera}, {lights} or {lens}', start_camera: 'Start with the camera',
    the_lights: 'the lights', the_lens: 'the lens', adding: 'Adding...',
    cart_error: 'Could not add to cart ({error}). Please try again.',
    quote_app: 'System from the configurator ({n} parts).', quote_have: "Customer's camera: {camera}.",
    link_copied: 'Link copied: anyone with it sees this system.', copy_prompt: 'Copy this link',
    updating: 'The configurator is being updated. Please try again in a few minutes, or {link}.', request_quote_link: 'request a quote',
    gone_one: 'That part is not in the configurator (it is sold on its own page); start your system here.',
    gone_other: '{n} parts from the link are not in the configurator; pick them on their product pages.'
  };
  var MAP = {};
  (function () {
    var el = document.querySelector('[data-ls-cfg-i18n]'), d = {};
    try { d = JSON.parse(el ? el.textContent : '{}') || {}; } catch (e) { d = {}; }
    var dec = document.createElement('textarea');  // the t filter HTML-escapes its output: keep plain text, esc() on use
    Object.keys(d).forEach(function (k) { if (k !== 'ui_map' && typeof d[k] === 'string' && d[k]) { dec.innerHTML = d[k]; STR[k] = dec.value; } });
    if (d.ui_map && typeof d.ui_map === 'object') MAP = d.ui_map;
  })();
  function S(key, vars) { return String(STR[key]).replace(/\{(\w+)\}/g, function (m, k) { return vars && vars[k] != null ? String(vars[k]) : m; }); }
  function P(key, n, vars) { vars = vars || {}; vars.n = n; return S(key + (n === 1 ? '_one' : '_other'), vars); }
  function tr(s) { return s != null && typeof MAP[s] === 'string' && MAP[s] ? MAP[s] : s; }  // display only
  // step-script strings (src/site/configurator/<step>.js): t("<step>.<name>", "English {n}", vars) -> the locale string
  // ls.cfg.steps.<step>.<name> (snippet key "<step>.<name>", generated by store_configurator.py), else the English
  function t(key, en, vars) {
    var s = STR[key];
    return String(typeof s === 'string' && s ? s : en).replace(/\{(\w+)\}/g, function (m, k) { return vars && vars[k] != null ? String(vars[k]) : m; });
  }
  var NOUS = STR.no_us;
  var toastTimer = 0;
  function toast(text, html) {
    var t = $('[data-cfg-toast]');
    if (!t) return;
    t.innerHTML = html ? text : esc(text);
    t.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.hidden = true; }, 5000);
  }

  window.LSConfig = {
    step: function (key, def) { DEF[key] = def; },
    set: function (name, value) { state.extra[name] = value; changed(); },
    get sys() { return sys; },
    get FORMAT_MM() { return META && META.formats; },
    get MOUNTS() { return (META && META.mounts) || []; },
    url: url, toast: function (text, html) { toast(html ? text : tr(text), html); }, money: money, esc: esc, tr: tr, t: t,
    start: start
  };

  function steps() { return META.steps; }
  function stepOf(key) { return steps().filter(function (s) { return s.key === key; })[0]; }
  function def(key) { return DEF[key] || {}; }
  function load(key) {
    if (DATA[key]) return Promise.resolve(DATA[key]);
    if (!LOADING[key]) LOADING[key] = fetch(META.files[key]).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); }).then(function (d) {
      var by = {};
      d.rows.forEach(function (r) { by[r.h] = r; });
      DATA[key] = { rows: d.rows, by: by };
      if (def(key).load) def(key).load(DATA[key]);
      return DATA[key];
    }).catch(function (e) { LOADING[key] = null; throw e; });
    return LOADING[key];
  }
  function rowOf(key, h) { return DATA[key] && DATA[key].by[h]; }
  function variant(r, code) { return r.v.filter(function (v) { return v[0] === code; })[0] || r.v[0]; }
  // Step tuples append the current checkout amount at [4]. Old files still use the model amount until refreshed.
  function unitPrice(r, code) {
    var v = variant(r, code);
    return r.p == null ? null : v && typeof v[4] === 'number' ? v[4] : r.p;
  }
  function priceHtml(r, code) {
    if (r.p == null) return esc(r.q ? STR.price_on_request : STR.quote);
    var prices = r.v.map(function (v) { return typeof v[4] === 'number' ? v[4] : r.p; });
    var lo = Math.min.apply(null, prices), hi = Math.max.apply(null, prices);
    var text = code == null && hi !== lo ? money(lo) + ' – ' + money(hi) : money(unitPrice(r, code));
    return text + (r.q ? '<small class="cfgqp">' + esc(STR.add_to_quote) + '</small>' : '');
  }
  function searchText(text) {
    // Own model numbers accept spaces, underscores and Unicode dashes; spec words remain separate tokens.
    return String(text || '').toLowerCase().replace(/[\u2010-\u2015\u2212]/g, '-')
      .replace(/\bls[\s_-]*([a-z]{3})[\s_-]*(\d{4})\b/g, 'ls-$1-$2')
      .replace(/(\d)\s+(mm|cm|nm|mp|v|w|x)\b/g, '$1$2');
  }

  // ---- system: recomputed from the picks after every change ----
  function recompute() {
    sys = {};
    if (state.have) Object.keys(state.have).forEach(function (k) { sys[k] = state.have[k]; });
    steps().forEach(function (s) {
      (state.picks[s.key] || []).forEach(function (p) {
        var r = rowOf(s.key, p.h);
        if (r && def(s.key).apply) def(s.key).apply(r, p, sys);
      });
    });
    Object.keys(state.extra).forEach(function (k) { sys[k] = state.extra[k]; });
  }
  function sysBefore(key) {
    var s0 = {};
    if (state.have) Object.keys(state.have).forEach(function (k) { s0[k] = state.have[k]; });
    var before = true;
    steps().forEach(function (s) {
      if (s.key === key) before = false;
      if (!before) return;
      (state.picks[s.key] || []).forEach(function (p) {
        var r = rowOf(s.key, p.h);
        if (r && def(s.key).apply) def(s.key).apply(r, p, s0);
      });
    });
    Object.keys(state.extra).forEach(function (k) { s0[k] = state.extra[k]; });
    return s0;
  }
  function rebuildAddons(from) {
    var keys = steps().map(function (s) { return s.key; }), i0 = from ? keys.indexOf(from) + 1 : 0;
    steps().slice(i0).forEach(function (s) {
      var d = def(s.key), l = state.picks[s.key];
      if (s.multi || !d.onPick || !l || !l.length || !DATA[s.key]) return;
      var p = l[l.length - 1], r = rowOf(s.key, p.h);
      if (!r) return;
      p.add = [];
      p.note = '';
      recompute();
      d.onPick(r, api(s.key));
    });
    changed();
  }

  // ---- URL ----
  function encodePick(p) {
    return [p.h, p.c || '', p.n || 1].concat(p.sel ? [encodeURIComponent(p.sel)] : []).join('~') + (p.add || []).map(function (a) { return ';' + [a.h, a.c || '', a.n || 1].join('~'); }).join('');
  }
  function decodePick(s) {
    var parts = s.split(';').map(function (x) {
      var f = x.split('~'), p = { h: f[0], c: f[1] || '', n: Math.max(1, parseInt(f[2], 10) || 1) };
      try { if (f[3]) p.sel = decodeURIComponent(f[3]).slice(0, 160); } catch (e) { p.malformed = true; }
      return p;
    });
    var p = parts[0];
    p.add = parts.slice(1);
    return p;
  }
  function writeUrl() {
    var q = new URLSearchParams();
    var keep = new URLSearchParams(location.search);  // Shopify's own parameters (preview_theme_id ...) stay
    keep.forEach(function (v, k) {
      if (/^(preview_theme_id|_ab|_fd|_sc|view|utm_[a-z_]+|gclid|dclid|gbraid|wbraid|msclkid|fbclid)$/.test(k)) q.append(k, v);
    });
    steps().forEach(function (s) { var l = state.picks[s.key]; if (l && l.length) q.set(s.key, l.map(encodePick).join(',')); });
    if (state.have) q.set('have', JSON.stringify(state.have));
    if (Object.keys(state.extra).length) q.set('set', JSON.stringify(state.extra));
    var sk = Object.keys(state.skipped).filter(function (k) { return state.skipped[k]; });
    if (sk.length) q.set('skip', sk.join(','));
    if (state.active) q.set('at', state.active);
    history.replaceState(null, '', location.pathname + (q.toString() ? '?' + q : '') + location.hash);
  }
  // DESIGN-QA 2026-10-21 (owner: lighting first): a bare /pages/configure opens the Lights step (the section's
  // data-default-start, default 'light') instead of Step 1 Camera; the camera stays in the bar, open (flow29b: it was
  // marked Skipped though nobody had skipped it; only ?skip=camera and the step's own skip button say that now).
  // Any configurator parameter (a pick, have, set, skip, at, start) keeps the old behaviour, so existing links work.
  function isFresh(q) {
    var keys = steps().map(function (s) { return s.key; }).concat(['have', 'set', 'skip', 'at', 'start']);
    return !keys.some(function (k) { return q.has(k); });
  }
  function defaultStart() {
    var root = $('[data-cfg-root]'), k = (root && root.dataset.defaultStart) || 'light';
    return stepOf(k) ? k : null;
  }
  function readUrl() {
    var q = new URLSearchParams(location.search);
    steps().forEach(function (s) {
      var v = q.get(s.key);
      if (v) state.picks[s.key] = v.split(',').filter(Boolean).map(decodePick);
    });
    var entry = q.get('selection'), entryPicks = [];
    steps().forEach(function (s) { entryPicks = entryPicks.concat(state.picks[s.key] || []); });
    if (entry && entry.length <= 160 && entryPicks.length === 1) {
      entryPicks[0].sel = entry;
      entryPicks[0].n = Math.max(1, parseInt(q.get('quantity'), 10) || 1);
    }
    try { state.have = q.get('have') ? JSON.parse(q.get('have')) : null; } catch (e) { state.have = null; }
    try { state.extra = q.get('set') ? JSON.parse(q.get('set')) : {}; } catch (e) { state.extra = {}; }
    (q.get('skip') || '').split(',').filter(Boolean).forEach(function (k) { state.skipped[k] = true; });
    var start = q.get('at') || q.get('start');
    if (start && start !== 'review' && !stepOf(start)) start = null;
    if (!start && isFresh(q)) start = defaultStart();  // no configuration in the URL: open the lights, as ?start=light does
    var root = $('[data-cfg-root]');
    if (root) root.classList.toggle('is-deep', !isFresh(q));  // a link into a step: on a phone the intro folds away (ls-cfg.css)
    var firstOpen = steps().filter(function (s) { return !state.picks[s.key] && !state.skipped[s.key]; })[0];
    state.active = start || (firstOpen ? firstOpen.key : 'review');
    autoActive = !start;
  }
  var autoActive = false;  // the step opened is the first one without a pick (no ?at= / ?start=): see start()

  // A PDP handoff resolves by the published variant ID, never by guessing a colour code from a SKU.
  // Condensed quote families validate the selected ID/configuration against their own live product first.
  function resolveSelection(key, p) {
    var r = rowOf(key, p.h);
    if (!r || p.malformed) return Promise.resolve(false);
    if (r.va && r.v.length === 1 && r.v[0][0] === '_') {
      var former = Object.keys(r.va);
      if (p.sel && former.some(function (c) { return String(r.va[c]) === p.sel; })) { p.c = '_'; delete p.sel; }
      if (!p.sel && Object.prototype.hasOwnProperty.call(r.va, p.c)) p.c = '_';
    }
    if (!p.sel) {
      if (p.c && !r.v.some(function (v) { return v[0] === p.c; })) return Promise.resolve(false);
      p.c = p.c || r.v[0][0];
      return Promise.resolve(true);
    }
    var direct = r.v.filter(function (v) { return String(v[2]) === p.sel; })[0];
    if (direct) { p.c = direct[0]; delete p.sel; return Promise.resolve(true); }
    if (!r.q || !r.o || r.ns) return Promise.resolve(false);
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var handle = quoteHandle(r), native = /^\d+$/.test(p.sel);
    return fetch(root + 'products/' + encodeURIComponent(handle) + (native ? '.js' : '?section_id=ls-product-main'),
      { headers: { Accept: native ? 'application/json' : 'text/html' } }).then(function (response) {
      if (!response.ok) throw new Error('selection');
      return native ? response.json() : response.text();
    }).then(function (data) {
      var chosen, name, price, vid = '', sku, options;
      if (native) {
        if (data.handle !== handle) return false;
        chosen = (data.variants || []).filter(function (v) { return String(v.id) === p.sel; })[0];
        if (!chosen) return false;
        name = chosen.public_title || chosen.title || '';
        price = Number(chosen.price) / 100; vid = String(chosen.id); sku = chosen.sku;
      } else {
        var doc = new DOMParser().parseFromString(data, 'text/html');
        var info = JSON.parse(($('[data-ls-quote-item]', doc) || {}).textContent || 'null');
        var cfg = JSON.parse(($('[data-ls-pick-data]', doc) || {}).textContent || 'null');
        if (!info || info.h !== handle || !cfg || !Array.isArray(cfg.n) || cfg.n.length > 32) return false;
        chosen = (cfg.c || []).filter(function (v) { return (cfg.p || '') + v[1] === p.sel; })[0];
        if (!chosen) return false;
        options = {}; var valid = true, w = cfg.w || 1;
        cfg.n.forEach(function (label, i) {
          var index = parseInt(String(chosen[0]).slice(i * w, i * w + w), 36);
          if (!Number.isInteger(index) || !cfg.v[i] || index < 0 || index >= cfg.v[i].length) { valid = false; return; }
          if (cfg.v[i][index]) options[label] = cfg.v[i][index];
        });
        if (!valid) return false;
        name = Object.keys(options).map(function (k) { return options[k]; }).join(' / ');
        price = chosen[2] == null ? null : Number(chosen[2]); sku = p.sel;
      }
      if (!sku || (price != null && (!Number.isFinite(price) || price < 0)) || (r.p != null && (!Number.isFinite(price) || price <= 0))) return false;
      r.v = [['_', name, vid, sku, price]];
      p.c = '_'; p.o = options;
      return true;
    });
  }

  // ---- picks ----
  function pick(key, h, code, n, note) {
    var s = stepOf(key), r = rowOf(key, h);
    if (!r) return;
    var p = { h: h, c: code || r.v[0][0], n: Math.max(1, n || 1), note: note || '', add: [] };
    if (s.multi) {
      var l = (state.picks[key] || []).filter(function (x) { return x.h !== h; });
      l.push(p);
      state.picks[key] = l;
    } else state.picks[key] = [p];
    state.skipped[key] = false;
    changed();
    rebuildAddons(key);
  }
  function unpick(key, h) {
    state.picks[key] = (state.picks[key] || []).filter(function (x) { return h && x.h !== h; });
    changed();
    rebuildAddons(key);
  }
  function addOn(key, h, code, n) {
    var l = state.picks[key];
    if (!l || !l.length) return;
    var p = l[l.length - 1];
    p.add = (p.add || []).filter(function (a) { return a.h !== h; });
    if (n !== 0) p.add.push({ h: h, c: code || '', n: n || 1 });
    changed();
  }
  function changed() { recompute(); writeUrl(); paintSummary(); paintStepper(); }
  function next() {
    var keys = steps().map(function (s) { return s.key; }).concat(['review']);
    go(keys[Math.min(keys.indexOf(state.active) + 1, keys.length - 1)]);
  }
  function go(key) {
    state.active = key;
    writeUrl();
    paintStepper();
    paintMain();
    var m = $('[data-cfg-main]');
    if (m && m.getBoundingClientRect().top < 0) m.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // ---- the generic step UI ----
  function fitOf(key, r) {
    var f = def(key).fit;
    var out = f ? f(r, sys) : [2, ''];
    return out || [2, ''];
  }
  function order(name, vals) {
    var o = (META.order || {})[name] || [];
    var num = function (v) { var m = String(v).match(/\d+(\.\d+)?/); return m ? parseFloat(m[0]) : 1e9; };
    return vals.sort(function (a, b) {
      var ia = o.indexOf(a), ib = o.indexOf(b);
      return (ia < 0 ? 999 : ia) - (ib < 0 ? 999 : ib) || num(a) - num(b) || String(a).localeCompare(String(b));
    });
  }
  function card(key, r, fit, picked) {
    var d = def(key), p = picked || {}, multi = stepOf(key).multi, no = blocked(r);
    var chips = (d.extra ? d.extra(r, sys) || [] : []).map(tr).concat((d.chips || []).map(function (n) { return arr(r.f[n]).map(tr).join(' / '); }).filter(Boolean)).slice(0, 5);
    var badge = fit[0] === 2 ? (fit[1] ? '<span class="fit ok">' + esc(tr(fit[1])) + '</span>' : '')
      : fit[0] === 1 ? '<span class="fit check">' + esc(S('check', { reason: fit[1] ? tr(fit[1]) : STR.fit_unstated })) + '</span>'
        : '<span class="fit no">' + esc(fit[1] ? tr(fit[1]) : STR.no_fit) + '</span>';
    var sw = r.v.length > 1 ? '<div class="cfgsw">' + r.v.map(function (v) {
      var on = picked ? (p.c || r.v[0][0]) === v[0] : false;
      return '<button type="button" class="cfgv' + (on ? ' on' : '') + '" data-code="' + esc(v[0]) + '" title="' + esc(tr(v[1])) + '"><i style="background:' + (SW[v[0]] || '#ccc') + '"></i>' + esc(tr(v[1])) + '</button>';
    }).join('') + '</div>' : r.o ? '<a class="cfgopt" href="' + esc(url(r)) + '" target="_blank" rel="noopener">' + esc(STR.options_note) + '</a>' : '';
    var price = priceHtml(r, picked ? p.c : null);
    var btn = no ? '<span class="cfgnous" title="' + esc(NOUS) + '">' + esc(STR.no_us_short) + '</span>'
      : '<button type="button" class="btn' + (picked ? ' ghost2' : '') + ' cfgpick">' + (picked ? (multi ? esc(STR.remove) : esc(STR.selected) + ' &#10003;') : esc(multi ? STR.add : STR.select)) + '</button>';
    return '<div class="cfgcard' + (picked ? ' on' : '') + (fit[0] === 0 || no ? ' nofit' : '') + '" data-h="' + esc(r.h) + '">' +
      '<a class="cfgimg" href="' + esc(url(r)) + '" target="_blank" rel="noopener" aria-label="' + esc(S('open_new_tab', { name: r.m })) + '">' +
      (r.i ? '<img loading="lazy" width="84" height="64" src="' + esc(r.i) + '" alt="">' : '<span class="cfgnoimg"></span>') + '</a>' +
      '<div class="cfgbd"><b>' + esc(r.t) + '</b><span class="cfgm">' + esc(r.m) + (r.f.Brand ? ' · ' + esc(r.f.Brand) : '') + '</span>' +
      (chips.length ? '<span class="cfgchips">' + chips.map(function (c) { return '<i>' + esc(c) + '</i>'; }).join('') + '</span>' : '') +
      badge + sw + '</div>' +
      '<div class="cfgbuy"><span class="cfgp">' + price + '</span>' +
      (d.qty && !no ? '<input class="qty cfgq" type="number" min="1" value="' + (p.n || 1) + '" aria-label="' + esc(STR.quantity) + '">' : '') + btn + '</div></div>';
  }
  function genericList(el, key) {
    var s = stepOf(key), d = def(key), data = DATA[key];
    var rows = data.rows.filter(function (r) { return !r.addon; });
    var picks = state.picks[key] || [];
    var pickedBy = {};
    picks.forEach(function (p) { pickedBy[p.h] = p; });
    var scored = rows.map(function (r) { return [r, fitOf(key, r)]; });
    var fitting = scored.filter(function (x) { return x[1][0] > 0 || pickedBy[x[0].h]; });
    var hidden = scored.length - fitting.length;
    var pool = state.showAll[key] ? scored : fitting;
    var f = state.filt[key] || (state.filt[key] = { cat: '', q: '', sel: {} });
    var gOf = d.group || function (r) { return r.c; };
    var gLabel = {};
    (d.groups || s.categories.map(function (c) { return [c, META.cats[c] || c]; })).forEach(function (g) { gLabel[g[0]] = g[1]; });
    var cats = {};
    pool.forEach(function (x) { var g = gOf(x[0]); cats[g] = (cats[g] || 0) + 1; });
    var catKeys = Object.keys(gLabel).filter(function (c) { return cats[c]; });
    var match = function (x, skip) {
      var r = x[0];
      if (f.cat && gOf(r) !== f.cat && skip !== 'cat') return false;
      if (f.q) {
        var hay = searchText(r.m + ' ' + r.t + ' ' + JSON.stringify(r.f));
        if (!searchText(f.q).trim().split(/\s+/).every(function (w) { return hay.indexOf(w) >= 0; })) return false;
      }
      return Object.keys(f.sel).every(function (n) { return n === skip || !f.sel[n] || arr(r.f[n]).indexOf(f.sel[n]) >= 0; });
    };
    var shown = pool.filter(function (x) { return match(x); });
    var rank = d.rank ? function (r) { var v = d.rank(r, sys); return v == null ? 1e9 : v; } : function () { return 0; };
    shown.forEach(function (x) { x[2] = rank(x[0]) + (blocked(x[0]) ? 1e12 : 0); });  // US: parts not sold here last
    shown.sort(function (a, b) { return (pickedBy[b[0].h] ? 1 : 0) - (pickedBy[a[0].h] ? 1 : 0) || b[1][0] - a[1][0] || a[2] - b[2]; });
    var selects = (d.filters || []).map(function (n) {
      var cnt = {};
      pool.forEach(function (x) { if (match(x, n)) arr(x[0].f[n]).forEach(function (v) { cnt[v] = (cnt[v] || 0) + 1; }); });
      var vals = order(n, Object.keys(cnt));
      if (vals.length < 2 && !f.sel[n]) return '';
      return '<label class="fsel">' + esc(tr(n)) + '<select data-fn="' + esc(n) + '"><option value="">' + esc(STR.any) + '</option>' + vals.map(function (v) {
        return '<option value="' + esc(v) + '"' + (f.sel[n] === v ? ' selected' : '') + '>' + esc(tr(v)) + ' (' + cnt[v] + ')</option>';
      }).join('') + '</select></label>';
    }).join('');
    var nsel = Object.keys(f.sel).filter(function (k) { return f.sel[k]; }).length;
    var ftoggle = selects ? '<button type="button" class="btn ghost2 cfgftoggle" data-ftoggle aria-expanded="' + (f.open ? 'true' : 'false') + '">' + esc(nsel ? S('filters_n', { n: nsel }) : STR.filters) + '</button>' : '';
    var n = state.page[key] || PAGE;
    var nous = us() ? shown.filter(function (x) { return blocked(x[0]); }).length : 0;
    el.innerHTML =
      (catKeys.length > 1 ? '<div class="cfgcats"><button type="button" data-cat=""' + (f.cat ? '' : ' class="on"') + '>' + esc(STR.all) + ' <i>' + pool.length + '</i></button>' +
        catKeys.map(function (c) { return '<button type="button" data-cat="' + esc(c) + '"' + (f.cat === c ? ' class="on"' : '') + '>' + esc(tr(gLabel[c])) + ' <i>' + cats[c] + '</i></button>'; }).join('') + '</div>' : '') +
      '<div class="filters cfgfilters' + (f.open ? ' is-open' : '') + '"><label class="fsel ftext">' + esc(STR.search) + '<input type="search" data-fq value="' + esc(f.q) + '" placeholder="' + esc(STR.search_placeholder) + '"></label>' + ftoggle + selects + '</div>' +
      '<p class="cfgcount">' + esc(S(state.showAll[key] ? 'count_all' : 'count_fit', { shown: shown.length, total: pool.length })) +
      (hidden ? ' · <button type="button" class="linkbtn" data-showall>' + esc(state.showAll[key] ? STR.only_fit : S('also_show', { n: hidden })) + '</button>' : '') +
      (nous ? ' · ' + esc(S('no_us_count', { n: nous })) : '') + '</p>' +
      '<div class="cfglist">' + (shown.length ? shown.slice(0, n).map(function (x) { return card(key, x[0], x[1], pickedBy[x[0].h]); }).join('')
        : '<p class="muted">' + esc(STR.no_match) + ' <button type="button" class="linkbtn" data-clear>' + esc(STR.clear_filters) + '</button></p>') + '</div>' +
      (shown.length > n ? '<button type="button" class="btn ghost2 cfgmore">' + esc(S('show_more', { n: shown.length - n })) + '</button>' : '');
    el.onclick = function (ev) {
      var t = ev.target.closest('button');
      if (!t) return;
      var c = t.closest('.cfgcard');
      if (t.hasAttribute('data-cat')) { f.cat = t.getAttribute('data-cat'); state.page[key] = PAGE; genericList(el, key); }
      else if (t.hasAttribute('data-ftoggle')) { f.open = !f.open; genericList(el, key); }
      else if (t.hasAttribute('data-showall')) { state.showAll[key] = !state.showAll[key]; genericList(el, key); }
      else if (t.hasAttribute('data-clear')) { state.filt[key] = null; genericList(el, key); }
      else if (t.classList.contains('cfgmore')) { state.page[key] = n + PAGE; genericList(el, key); }
      else if (t.classList.contains('cfgv') && c) {
        $$('.cfgv', c).forEach(function (b) { b.classList.toggle('on', b === t); });
        $('.cfgp', c).innerHTML = priceHtml(rowOf(key, c.dataset.h), t.dataset.code);
        var pk = pickedBy[c.dataset.h];
        if (pk) { pk.c = t.dataset.code; changed(); }
      } else if (t.classList.contains('cfgpick') && c) {
        var h = c.dataset.h, on = $('.cfgv.on', c), q = $('.cfgq', c);
        if (pickedBy[h] && s.multi) { unpick(key, h); genericList(el, key); return; }
        if (pickedBy[h]) { next(); return; }
        if (blocked(rowOf(key, h))) { toast(NOUS); return; }
        if (!on && $('.cfgv', c)) {
          $('.cfgsw', c).classList.add('need');
          toast(STR.choose_variant);
          return;
        }
        pick(key, h, on ? on.dataset.code : '', q ? parseInt(q.value, 10) : 1);
        if (d.onPick) d.onPick(rowOf(key, h), api(key));
        if (s.multi) genericList(el, key); else next();
      }
    };
    el.onchange = function (ev) {
      var t = ev.target;
      if (t.hasAttribute('data-fn')) { f.sel[t.getAttribute('data-fn')] = t.value; state.page[key] = PAGE; genericList(el, key); }
      else if (t.classList.contains('cfgq')) {
        var pk = pickedBy[t.closest('.cfgcard').dataset.h];
        if (pk) { pk.n = Math.max(1, parseInt(t.value, 10) || 1); changed(); }
      }
    };
    var fq = $('[data-fq]', el);
    fq.oninput = function () {
      f.q = fq.value.trim();
      clearTimeout(fq._t);
      fq._t = setTimeout(function () {
        if (!fq.isConnected || state.active !== key) return;
        var focused = document.activeElement === fq, pos = fq.selectionStart;
        genericList(el, key);
        if (focused) { var nq = $('[data-fq]', el); nq.focus(); nq.setSelectionRange(pos, pos); }
      }, 200);
    };
  }

  function api(key) {
    return {
      get sys() { return sys; }, get rows() { return DATA[key] ? DATA[key].rows : []; }, row: function (h) { return rowOf(key, h); },
      picks: function () { return state.picks[key] || []; },
      pick: function (h, code, n, note) { if (blocked(rowOf(key, h))) { toast(NOUS); return; } pick(key, h, code, n, note); },
      add: function (h, code, n) { addOn(key, h, code, n); },
      note: function (text) { var l = state.picks[key]; if (l && l.length) { l[l.length - 1].note = text; changed(); } },
      refresh: function () {
        var m = $('[data-cfg-main]'), b = m && $('[data-body]', m), d = def(key);
        if (!b || state.active !== key) return;
        $('[data-note]', m).innerHTML = d.note ? tr(d.note(sys) || '') : '';
        if (d.render) d.render(b, api(key)); else genericList(b, key);
      },
      unpick: function (h) { unpick(key, h); },
      next: next, set: window.LSConfig.set, have: function (v) { state.have = v; state.skipped.camera = !!v; changed(); rebuildAddons('camera'); },
      card: function (r, fit) { return card(key, r, fit || fitOf(key, r), (state.picks[key] || []).filter(function (p) { return p.h === r.h; })[0]); },
      list: function (el) { genericList(el, key); },
      money: money, esc: esc
    };
  }

  function paintMain() {
    var m = $('[data-cfg-main]'), key = state.active;
    if (key === 'review') { paintReview(m); return; }
    var s = stepOf(key), d = def(key);
    var i = steps().indexOf(s);
    var ico = $('template[data-cfg-ico="' + key + '"]');
    m.innerHTML = '<div class="cfgstep"><div class="cfgquest">' + (ico ? '<span class="cfgqico">' + ico.innerHTML + '</span>' : '') +
      '<div><p class="cat">' + esc(i > 0 && !lines().length && !state.have ? STR.any_order : S('step_of', { n: i + 1, total: steps().length + 1 })) + ' · ' + esc(tr(s.label)) + '</p><h2>' + esc(tr(s.question)) + '</h2>' +
      '<p class="cfgnote" data-note></p></div></div><div data-top></div><div data-body><p class="muted">' + esc(STR.loading_parts) + '</p></div>' +
      '<div class="cfgnav">' + (i > 0 ? '<button type="button" class="btn ghost2" data-prev>&larr; ' + esc(STR.back) + '</button>' : '') +
      '<button type="button" class="btn ghost2" data-skip>' + esc((state.picks[key] || []).length ? STR.next_step : d.skip ? tr(d.skip) : STR.skip_step) + ' &rarr;</button></div></div>';
    if ($('[data-prev]', m)) $('[data-prev]', m).onclick = function () { go(steps()[i - 1].key); };
    $('[data-skip]', m).onclick = function () { if (!(state.picks[key] || []).length) state.skipped[key] = true; changed(); next(); };
    $('[data-note]', m).innerHTML = d.note ? tr(d.note(sys) || '') : '';
    if (d.top) d.top($('[data-top]', m), api(key));
    load(key).then(function () {
      if (state.active !== key) return;
      var a = api(key);
      $('[data-note]', m).innerHTML = d.note ? tr(d.note(sys) || '') : '';
      if (d.render) d.render($('[data-body]', m), a); else genericList($('[data-body]', m), key);
    }).catch(function () { var b = $('[data-body]', m); if (b) b.innerHTML = '<p class="muted">' + esc(STR.load_error) + '</p>'; });
  }

  // ---- summary, review, stepper ----
  function lines() {
    var out = [];
    steps().forEach(function (s) {
      (state.picks[s.key] || []).forEach(function (p) {
        var r = rowOf(s.key, p.h);
        if (!r) return;
        var d = def(s.key), f = d.fit ? d.fit(r, sysBefore(s.key)) || [2, ''] : [2, ''];
        out.push({ step: s.key, r: r, c: p.c, n: p.n, note: p.note, fit: f, o: p.o });
        (p.add || []).forEach(function (a) { var ar = rowOf(s.key, a.h); if (ar) out.push({ step: s.key, r: ar, c: a.c, n: a.n, add: true }); });
      });
    });
    return out;
  }
  function totals(ls) {  // cart = Buy now parts; quoted = priced parts that go to the quote list; US: parts not sold here go nowhere
    var ok = ls.filter(function (l) { return !blocked(l.r); });
    var buy = ok.filter(function (l) { return !l.r.q && l.r.p != null && variant(l.r, l.c)[2]; });
    var qp = ok.filter(function (l) { return l.r.q && l.r.p != null; });
    return { buy: buy, sum: buy.reduce(function (t, l) { return t + unitPrice(l.r, l.c) * l.n; }, 0), quote: ok.length - buy.length,
      qsum: qp.reduce(function (t, l) { return t + unitPrice(l.r, l.c) * l.n; }, 0), qn: qp.length, nous: ls.length - ok.length, ok: ok };
  }
  function lineHtml(l, compact) {
    var v = variant(l.r, l.c);
    return '<div class="cfgline' + (l.add ? ' sub' : '') + '">' + (l.r.i ? '<img src="' + esc(l.r.i) + '" alt="" loading="lazy" width="44" height="36">' : '<span class="cfgnoimg"></span>') +
      '<div><a href="' + esc(url(l.r)) + '" target="_blank" rel="noopener">' + esc(compact ? l.r.m : l.r.t) + '</a>' +
      '<span>' + (v[1] ? esc(tr(v[1])) + ' · ' : '') + (compact ? '' : esc(l.r.m) + ' · ') + esc(S('qty', { n: l.n })) + (l.note ? ' · ' + esc(tr(l.note)) : '') + '</span>' +
      (l.fit && l.fit[0] === 0 ? '<span class="fit no">' + esc(S('no_longer_fits', { reason: l.fit[1] ? tr(l.fit[1]) : STR.check_step })) + '</span>' : '') +
      (blocked(l.r) ? '<span class="fit no">' + esc(NOUS) + '</span>' : '') + '</div>' +
      '<b>' + (l.r.p != null ? money(unitPrice(l.r, l.c) * l.n) + (l.r.q ? ' <small class="cfgqp">' + esc(STR.quote_small) + '</small>' : '') : esc(STR.quote)) + '</b></div>';
  }
  function actions(ls, t) {
    if (!ls.length) return '<p class="muted small">' + esc(STR.pick_hint) + '</p>';
    var nous = t.nous ? '<p class="fit no">' + esc(P('nous', t.nous)) + '</p>' : '';
    var bad = ls.filter(function (l) { return l.fit && l.fit[0] === 0; });
    if (bad.length) return nous + '<p class="fit no">' + esc(P('bad', bad.length)) + '</p>' +
      (t.ok.length ? '<button type="button" class="btn ghost2 cfgquote" data-quote>' + esc(STR.request_quote) + '</button>' : '');
    return nous + (t.buy.length ? '<button type="button" class="btn cfgcart" data-cart>' + esc(P('add_cart', t.buy.length, { sum: money(t.sum) })) + '</button>' : '') +
      (t.ok.length ? '<button type="button" class="btn ' + (t.buy.length ? 'ghost2' : '') + ' cfgquote" data-quote>' + esc(STR.request_quote) + '</button>' : '') +
      (t.qn ? '<div class="cartsub"><span>' + esc(S('quoted_parts', { n: t.qn })) + '</span><b>' + money(t.qsum) + '</b></div>' : '') +
      (t.quote ? '<p class="muted small">' + esc(P('on_quote', t.quote)) +
        (t.quote > t.qn ? ' (' + esc(S('on_request', { n: t.quote - t.qn })) + ')' : '') + (t.buy.length ? '; ' + esc(STR.cart_takes) + '.' : '.') + '</p>' : '') +
      '<p class="cfglinks"><button type="button" class="linkbtn" data-share>' + esc(STR.copy_link) + '</button> · <button type="button" class="linkbtn" data-reset>' + esc(STR.start_over) + '</button></p>';
  }
  function paintSummary() {
    var a = $('[data-cfg-summary]'), ls = lines(), t = totals(ls);
    var by = {};
    ls.forEach(function (l) { (by[l.step] = by[l.step] || []).push(l); });
    var haveTxt = state.have ? '<div class="cfgline have"><div><b>' + esc(STR.your_camera) + '</b><span>' + esc([state.have.mount, state.have.fmt, state.have.iface].filter(Boolean).join(' · ')) + '</span></div></div>' : '';
    a.innerHTML = '<div class="cfgsumin"><h2>' + esc(STR.your_system) + '</h2>' + haveTxt + steps().map(function (s) {
      var l = by[s.key];
      return '<div class="cfgsrow"><div class="cfgshead"><span>' + esc(tr(s.label)) + '</span><button type="button" class="linkbtn" data-goto="' + s.key + '">' + esc(l ? STR.change : state.skipped[s.key] ? STR.skipped : STR.choose) + '</button></div>' +
        (l ? l.map(function (x) { return lineHtml(x, true); }).join('') : '') + '</div>';
    }).join('') + (t.buy.length ? '<div class="cartsub"><span>' + esc(STR.priced_parts) + '</span><b>' + money(t.sum) + '</b></div>' : '') + actions(ls, t) + '</div>' +
      '<div class="cfgbar"><span>' + esc(P('parts', ls.length)) + (t.buy.length ? ' · ' + money(t.sum) : '') + '</span><button type="button" class="btn" data-goto="review">' + esc(STR.review) + '</button></div>';
  }
  // Non-blocking: a light with nothing to run it. Same data as the controller step (the light's x.volt, the PC's x.lch).
  function powerWarning() {
    var lp = (state.picks.light || [])[0], lr = lp && rowOf('light', lp.h);
    if (!lr || blocked(lr) || (state.picks.controller || []).length) return '';
    var volt = ((lr.x || {}).volt || []).join(' / '), pp = (state.picks.pc || [])[0], pr = pp && rowOf('pc', pp.h), lch = pr && (pr.x || {}).lch;
    var vars = { model: lr.m, volt: volt, pc: pr ? pr.m : '', n: lch || 0 };
    var text = lch ? S(volt ? 'power_pc' : 'power_pc_unknown', vars)
      : S(volt ? 'power_v' : 'power_unknown', vars) + ' ' + STR.power_have;
    return '<div class="cfgwarn" role="note"><b>' + esc(STR.power_title) + '</b><p>' + esc(text) + '</p>' +
      '<button type="button" class="btn ghost2" data-goto="controller">' + esc(STR.power_choose) + '</button></div>';
  }
  function paintReview(m) {
    Promise.all(steps().map(function (s) { return (state.picks[s.key] || []).length ? load(s.key) : null; })).then(function () {
      if (state.active !== 'review') return;
      var ls = lines(), t = totals(ls);
      m.innerHTML = '<div class="cfgstep"><div class="cfgquest"><span class="cfgqico">' + (($('template[data-cfg-ico="review"]') || {}).innerHTML || '') + '</span><div><p class="cat">' + esc(STR.review) + '</p><h2>' + esc(STR.your_system) + '</h2></div></div>' +
        (ls.length ? '<div class="cfgreview">' + ls.map(function (l) { return lineHtml(l, false); }).join('') + '</div>' + powerWarning() +
          (t.buy.length ? '<div class="cartsub"><span>' + esc(STR.priced_parts) + '</span><b>' + money(t.sum) + '</b></div>' : '') +
          '<p class="note">' + esc(STR.checkout_note) + '</p>' + actions(ls, t)
          : '<p class="muted">' + esc(STR.nothing_yet) + ' ' + esc(STR.start_from).replace('{camera}', '<button type="button" class="linkbtn" data-goto="' + steps()[0].key + '">' + esc(STR.start_camera) + '</button>')
            .replace('{lights}', '<button type="button" class="linkbtn" data-goto="light">' + esc(STR.the_lights) + '</button>')
            .replace('{lens}', '<button type="button" class="linkbtn" data-goto="lens">' + esc(STR.the_lens) + '</button>') + '</p>') +
        '<div class="cfgnav"><button type="button" class="btn ghost2" data-goto="' + steps()[steps().length - 1].key + '">&larr; ' + esc(STR.back) + '</button></div></div>';
    }).catch(function () { m.innerHTML = '<p class="muted">' + esc(STR.load_error) + '</p>'; });
  }
  function paintStepper() {
    $$('[data-cfg-steps] [data-goto]').forEach(function (b) {
      var k = b.dataset.goto;
      b.classList.toggle('on', k === state.active);
      b.classList.toggle('done', !!(state.picks[k] || []).length);
      b.classList.toggle('skip', !!state.skipped[k] && !(state.picks[k] || []).length);
      if (k === state.active) b.setAttribute('aria-current', 'step'); else b.removeAttribute('aria-current');
    });
  }

  // ---- buy / quote ----
  // Horizon's routes (snippets/scripts.liquid: a global `const Theme`, locale-aware; cart_add_url already ends in .js)
  function routes() { try { return (typeof Theme !== 'undefined' && Theme.routes) || {}; } catch (e) { return {}; } }
  function addUrl() { var u = routes().cart_add_url || '/cart/add.js'; return /\.js$/.test(u) ? u : u + '.js'; }
  function cartUrl() { return routes().cart_url || '/cart'; }
  function toCart(btn) {
    var t = totals(lines());
    var items = t.buy.map(function (l) { return { id: Number(variant(l.r, l.c)[2]), quantity: l.n }; });
    if (!items.length) return;
    btn.disabled = true;
    btn.textContent = STR.adding;
    var sections = $$('cart-items-component').map(function (c) { return c.dataset.sectionId; }).filter(Boolean);
    var ev = null;
    var mods = window.LSCfgModules || null;  // set by the section's inline module (import() is unavailable in classic assets)
    var events = Promise.resolve(mods && mods.events);
    events.then(function (E) {
      if (E && E.CartLinesUpdateEvent) {  // Horizon's cart drawer + bubble listen for this (product-form.js does the same)
        ev = E.CartLinesUpdateEvent.createPromise();
        btn.dispatchEvent(new E.CartLinesUpdateEvent({ action: 'add', context: 'product',
          lines: items.map(function (i) { return { merchandiseId: 'gid://shopify/ProductVariant/' + i.id, quantity: i.quantity }; }), promise: ev.promise }));
      }
      return fetch(addUrl(), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items, sections: sections.join(','), sections_url: location.pathname }) })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          return fetch(cartUrl() + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
            if (ev) ev.resolve({ cart: E.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
              detail: { items: cart.items, sections: res.sections, didError: !!res.status, source: 'ls-configurator', itemCount: items.length } });
            if (res.status) throw new Error(res.description || res.message || 'Add to cart failed');
            var drawer = document.getElementById('cart-drawer');
            if (!drawer) { location.href = cartUrl(); return; }
            // the drawer's own listener may not be live yet (an empty drawer's items component): put the fresh section
            // HTML in place ourselves (same HTML, so a second morph by the component changes nothing), then open it
            var html = res.sections || {};
            return Promise.resolve(mods && mods.renderer).then(function (R) {
              if (!R) return;
              return Promise.all(Object.keys(html).filter(function (id) { return html[id]; }).map(function (id) {
                return R.morphSection(id, html[id], { mode: 'full', injectStylesheet: true }).catch(function () { /* the component re-renders */ });
              }));
            }).catch(function () { /* no renderer: the drawer still opens */ }).then(function () {
              if (typeof drawer.open === 'function' && !drawer.isOpen) drawer.open();
            });
          });
        });
    }).then(function () { btn.disabled = false; paintSummary(); if (state.active === 'review') paintMain(); })
      .catch(function (e) { if (ev) ev.reject(e); btn.disabled = false; paintSummary(); if (state.active === 'review') paintMain(); toast(S('cart_error', { error: e.message })); });
  }
  function toQuote() {
    var Q = window.LSQuote;
    var ok = totals(lines()).ok;
    if (!Q || !Q.add) { location.href = META.quote_url || '/pages/quote'; return; }
    ok.forEach(function (l) {
      var v = variant(l.r, l.c);
      var item = { v: v[2], sku: v[3], t: l.r.t, h: quoteHandle(l.r), i: l.r.i, q: l.n };
      if (l.o) item.o = l.o;
      if (l.r.u) item.u = l.r.u;
      if (l.r.nu) item.nu = 1;
      Q.add(item);
    });
    var have = state.have ? ' ' + S('quote_have', { camera: [state.have.mount, state.have.fmt, state.have.iface].filter(Boolean).join(', ') }) : '';
    try {  // the quote page prefills Application and sends source + config (draft tagged "configurator")
      sessionStorage.setItem('lumaspec-quote-app', S('quote_app', { n: ok.length }) + have);
      sessionStorage.setItem('lumaspec-quote-config', location.href);
      sessionStorage.setItem('lumaspec-quote-source', 'configure');
    } catch (e) { /* storage blocked */ }
    location.href = META.quote_url || '/pages/quote';
  }
  document.addEventListener('click', function (ev) {
    var t = ev.target.closest('[data-goto],[data-cart],[data-quote],[data-share],[data-reset]');
    if (!t || !t.closest('[data-cfg-root]')) return;
    if (t.hasAttribute('data-goto')) {
      var g = t.dataset.goto;
      go(g);
      if (t.hasAttribute('data-start')) { var m = $('[data-cfg-main]'); if (m) m.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    }
    else if (t.hasAttribute('data-cart')) toCart(t);
    else if (t.hasAttribute('data-quote')) toQuote();
    else if (t.hasAttribute('data-share')) {
      var done = function () { toast(STR.link_copied); };
      if (navigator.clipboard) navigator.clipboard.writeText(location.href).then(done, function () { prompt(STR.copy_prompt, location.href); });
      else prompt(STR.copy_prompt, location.href);
    } else if (t.hasAttribute('data-reset')) {
      var ds = defaultStart();  // start over where a fresh page starts (the lights); the camera stays open, not "skipped"
      state = { picks: {}, have: null, extra: {}, skipped: {}, active: ds || steps()[0].key, showAll: {}, filt: {}, page: {} };
      changed(); paintMain();
    }
  });

  function start() {
    var el = $('#cfg-meta');
    try { META = JSON.parse(el.textContent); } catch (e) { META = null; }
    var root = $('[data-cfg-root]');
    if (META && root) { META.country = root.dataset.country || ''; META.quote_url = root.dataset.quoteUrl || '/pages/quote'; }
    if (!META || !META.steps || !META.files) {
      var m = $('[data-cfg-main]');
      if (m) m.innerHTML = '<p class="muted">' + esc(STR.updating).replace('{link}', '<a href="' + esc((META && META.quote_url) || '/pages/quote') + '">' + esc(STR.request_quote_link) + '</a>') + '</p>';
      return;
    }
    readUrl();
    var need = steps().filter(function (s) { return (state.picks[s.key] || []).length; }).map(function (s) { return load(s.key); });
    Promise.all(need).then(function () {
      var resolving = [];
      steps().forEach(function (s) {
        (state.picks[s.key] || []).forEach(function (p) {
          resolving.push(resolveSelection(s.key, p).then(function (valid) { p.invalid = !valid; }).catch(function () {
            p.invalid = true; p.failed = true;
          }));
        });
      });
      return Promise.all(resolving);
    }).then(function () {
      var gone = 0, invalid = 0, failed = false;
      steps().forEach(function (s) {
        if (!state.picks[s.key]) return;
        var keep = state.picks[s.key].filter(function (p) {
          if (!rowOf(s.key, p.h)) { gone++; return false; }
          if (p.invalid) { invalid++; failed = failed || p.failed; return false; }
          return true;
        });
        state.picks[s.key] = keep;
      });
      if ((gone || invalid) && autoActive) {  // a dropped pick no longer moves the visitor past its step
        var open = steps().filter(function (s) { return !(state.picks[s.key] || []).length && !state.skipped[s.key]; })[0];
        state.active = open ? open.key : 'review';
      }
      rebuildAddons(null);
      paintMain();
      if (failed) toast(STR.load_error);
      else if (invalid) toast(STR.choose_variant);
      else if (gone) toast(P('gone', gone));
    }).catch(function () { changed(); paintMain(); });
  }
})();
